<template>
  <v-container
    fluid fill-height
    justify-center
    align-center
    class="p-appy-welcome pa-0 ma-0"
  >
    <v-layout
      justify-center
      align-center
      row
      fill-height
      class="p-appy-background"
    >
      <v-flex xs10 md8 lg5 xl4 class="appy-blur">
        <v-card flat class="pa-5 mx-4 transparent">
          <v-card-title primary-title class="align-center justify-center">
            <div>
              <div class="font-raleway appy-header pa-1 appy-text-shadow-white">OOOPS! NO ACCESS</div>
            </div>
          </v-card-title>
          <v-card-text>
            <p class="font-open_sans appy-subhead-2 px-5 py-1">To access the Appy Studio please sign-in below.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn href="/user/login/" color="appy-color gray-1" large dark><span class="font-raleway appy-header appy-sm">LOGIN</span></v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import DefaultAppyComponent from '~/src/mixins/DefaultAppyComponent'
  import { mapState } from 'vuex'

  export default {
    name: "Index",
    layout: 'appystudiotopbar',
    mixins: [DefaultAppyComponent],
    mounted () {
      this.dataIsStylePosition = 'none'
    },
    computed: {
      ...mapState({
        theme: state => state.emailEditor.theme,
        eventData: state => state.emailEditor.eventData,
        userSession: state => state.user.session
      }),
    },
    props: {},
    data() {
      return {
        dataIsStylePosition: 'none'
      }
    }
  }
</script>

<style lang="scss">
  .p-appy-background {
    background: url('~assets/img/email_editor/general/appystudio-welcome-bckg.jpg') fixed no-repeat;
    background-size: cover;
  }
</style>
